import { Component, OnInit, Input , Output, EventEmitter} from '@angular/core';
import { City } from '../../../model/city'
import { BaseItemComponent } from '../base-item/base-item.component'
import { DataService } from '../../../services/data.service'
import { environment } from '../../../constants'
import { FormGroup, FormControl, FormsModule, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { AppUserAuth } from '../../../security/app-user-auth'
import { SecurityService } from '../../../security/security.service'
import { StringValidator } from '../base-item/string.validator'

@Component({
  selector: 'app-city-item',
  templateUrl: '../../../base-classes/abstract-base-item/abstract-base-item.component.html',
  styleUrls: ['../../../styles/global.scss','../../../base-classes/abstract-base-item/abstract-base-item.component.scss']
})
export class CityItemComponent extends BaseItemComponent {

  @Input() public name: string
  item: City

  setParams(params) {
    this.name = params['id']
  }

  getItem() {
    this.dataService.getCity(this.name)
    .subscribe(item => {
      console.log("ITEM = ", item)
      this.dataGetSuccess(item)
    })
  }

  disableField(field: string, ctrls: any) {
    if (field == 'name')
      ctrls[field].disable()
  }


  updateItem() {
    let st = this.item
    let cat = st.toJson()
    this.dataService.updateCity(cat)
    .subscribe(
      val => {
        this.dataSuccess(val, 'PUT')
      },
      err => this.dataError(err, 'PUT'),
      () => {}
    )
  }

  deleteItem() {
    let st = this.item
    this.dataService.deleteCity(st.name)
    .subscribe(
      val => this.dataSuccess(val, 'DELETE'),
      err => this.dataError(err, 'DELETE'),
      () => {}
    )
  }

  getValidators() {
    let vals = {}
    vals["countryCode"] = [Validators.required, StringValidator.cannotContainSpace]
    vals["countryName"] = [Validators.required]
    vals["name"] = [Validators.required, StringValidator.cannotContainSpace]
    return vals
  }

  getDisabledFields() {
    let list = ["name"]
    return list
  }

  getItemName() {
    return "City"
  }

  getItemNames() {
    return "Cities"
  }

  getItemId() {
    return this.name
  }

  getLinkToList() {
    return "/data/constants/cities/"
  }

  duplicateItem() {
    let newItem = new City()
    newItem.copy(this.item)
    this.item = newItem
    this.updateForm()
  }


}
